import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from "../_services/auth.service";
import {NotificationsService} from "../_services/notifications.service";
import {SnackbarService} from "../_services/snackbar.service";

@Component({
    selector: 'app-passthrough',
    templateUrl: './passthrough.component.html',
    styleUrls: ['./passthrough.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PassthroughComponent implements OnInit {
    isRaa: boolean = false;

    constructor(private route: ActivatedRoute,
                private readonly router: Router,
                private authService: AuthService,
                private notificationService: NotificationsService,
                private snackbarService: SnackbarService
    ) {
        localStorage.removeItem('userRoles');
        this.authService.getDynamicSettings().then((r): void => {
            this.isRaa = r.is_raa;
        });
    }

    ngOnInit(): void {
        this.route.queryParams
            .subscribe(params => {
                    if (params['magicToken']) {
                        // A new sign-in must not inherit the previous user's session or timers.
                        this.authService.clearStore();
                        this.authService.loginWithMagicToken(params['magicToken']).subscribe({
                            next: r => {
                                this.authService.setToken(r.data.token);
                                this.authService.setSessionToken(r.data.session_token);
                                this.authService.setUserWithToken(r.data.token, false).then((): void => {
                                    if (r.data.user.role.role_type == "admin") {
                                        this.router.navigate(['/reporting'], {replaceUrl: true});
                                    } else if (this.isRaa && r.data.user.role.role_type == "young_person" && r.data.user.role.name != 'Adult (18+)') {
                                        this.router.navigate(['/noBoxes'], {replaceUrl: true});
                                    } else {
                                        this.router.navigate(['/people'], {replaceUrl: true});
                                    }
                                }).catch(error => this.handleSigninError(error));

                            }, error: error => this.handleSigninError(error)
                        });


                    } else if (params['token'] && !params['notification']) {
                        // Pass token to hijack the user
                        this.authService.setUserWithToken(params['token'], true).then((): void => {
                            this.router.navigate(['/people']);
                        }).catch((err): void => {
                            this.router.navigate(['/login']);
                        });
                    } else if (params['notification']) {
                        if (this.authService.isLoggedIn()) {
                            // is logged in so redirect to correct notification link
                            this.getNotificationLink(params['notification'])
                        } else if (params['token']) {
                            // is not logged in but has token so login then redirect
                            this.authService.setUserWithToken(params['token'], false).then((): void => {
                                this.getNotificationLink(params['notification']);
                            }).catch((err): void => {
                                this.router.navigate(['/login']);
                            });
                        } else {
                            // Go back to login and come back here when logged in
                            this.router.navigate(['/login'], {queryParams: {returnUrl: window.location.href}});
                        }
                    } else if (params['azureCode']) {
                        // replaceUrl keeps the consumed one-time code out of the
                        // history, so Back doesn't retry a dead code and error
                        this.authService.clearStore();
                        this.authService.finishAzureSignin(params['azureCode']).subscribe({
                            next: r => {
                                this.authService.setToken(r.token);
                                this.authService.setSessionToken(r.session_token);

                                this.authService.setUserWithToken(r.token, false).then((): void => {
                                    if (r.user.role.role_type == "young_person") {
                                        // Will be child or adult or admin in prod
                                        if (this.isRaa) {
                                            //     Children have no access
                                            this.router.navigate(['/noBoxes'], {replaceUrl: true});
                                        } else {
                                            this.router.navigate(['/people'], {replaceUrl: true});
                                        }
                                    } else if (r.user.role.role_type == "admin") {
                                        this.router.navigate(['/reporting'], {replaceUrl: true});
                                    } else {
                                        this.router.navigate(['/people'], {replaceUrl: true});
                                    }
                                }).catch(error => this.handleSigninError(error));
                            }, error: error => this.handleSigninError(error)
                        });

                    } else {
                        // No useful params why are you here?
                        this.router.navigate(['/login']);
                    }
                }
            );
    }

    private handleSigninError(error: unknown): void {
        this.authService.clearStore();
        this.snackbarService.openSnackBar(error, 'error');
        console.error(error);
        this.router.navigate(['/login'], {replaceUrl: true});
    }

    getNotificationLink(id: number): void {
        this.notificationService.getNotification(id).subscribe({
            next: r => {
                const link = this.notificationService.getNotificationLink(r)?.url;
                if (link) {
                    window.location.href = link;
                } else {
                    this.router.navigate(['/people']);
                }
            }, error: error => {
                this.snackbarService.openSnackBar(error, 'error')
                console.error(error)
                this.router.navigate(['/login']);
            }
        });
    }
}
